var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "132px",
    height: "98px",
    viewBox: "0 0 132 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "envelope") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#989898",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.2,
    y: 0.2,
    width: 128.4,
    height: 94.4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0.1 2.1 64.4 47.4 128.6 2.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.84836d2dc3020fc7e4b39cc3108609fa.svg";
export { ForwardRef as ReactComponent };